const billingSectionEN = {
    activateTitle: "Activate Your Shop",
    activateSubtitle: "Complete your subscription to start accepting bookings.",
    totalSeats: "Total Seats",
    staffSeats: "Staff Seats",
    poweredBy: "Secure payments powered by Paddle",
}

export default billingSectionEN